<app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"> </app-brand-header>

<form  data-aci-speedpay role="form" [formGroup]="cardForm">
  <main class="dsb-cards-container">
    <div class="dsb-card-wrapper">

      <div  class="dsb-card">

        <h3>Add Debit Card</h3>

        <div class="link-wrapper">
            <a href='/dsb-ocr' >Back to Available Funds</a>
        </div>

        <h2></h2>

        <div class="row">
            <div class="form-group">
              <label>Name on Account</label>
              <div class="input-group">
                <input type="text" data-aci-speedpay="account-holder-name" formControlName="account-holder-name"
                    minlength="1" maxlength="45"
                    class="form-control" id="account-holder-name" placeholder="Account holder's name" />
                <!-- <div class="input-group-append">
                    <span class="input-group-text"><fa-icon [icon]="faAddressCard"></fa-icon></span>
                </div> -->
              </div>
              <div *ngIf="!cardForm.controls['account-holder-name'].valid && cardForm.controls['account-holder-name'].dirty" class="alert alert-danger">
                  Name on account must be provided
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <label>Card Number</label>
              <div class="input-group">
<!--                   
                <input type="text" data-aci-speedpay="card-number" formControlName="card-number" 
                    pattern="^[0-9]{4}[ ][0-9]{4}[ ][0-9]{4}[ ][0-9]{4}(?:[ ])?(?:[0-9]{3})?$" [textMask]="{mask: mask1}"
                    class="form-control" id="card-number" placeholder="0000 0000 0000 0000" />
 -->
                    <div data-aci-speedpay="card-number"></div>                    
              </div>
              <div *ngIf="!cardForm.controls['iframe-card-number'].valid && cardForm.controls['iframe-card-number'].dirty" class="alert alert-danger">
                  Incorrect account number
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label>Expiration Date</label>
                    <div class="input-group">
<!-- 
                      <input type="text" data-aci-speedpay="expiration-date" formControlName="expiration-date"
                          pattern="^[0-9]{2}[/][0-9]{2}$" [textMask]="{mask: mask2}"
                          class="form-control" id="expiration-date" placeholder="MM/YY" />
                           -->
                           <div data-aci-speedpay="expiration-date" ></div>                           
                    </div>
                    <div *ngIf="!cardForm.controls['iframe-expiration-date'].valid && cardForm.controls['iframe-expiration-date'].dirty" class="alert alert-danger">
                        Incorrect expiration date
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                <label>CVV</label>
                <div class="input-group">
<!-- 
                    <input type="text" data-aci-speedpay="security-code" formControlName="security-code"
                        pattern="^[0-9]*$" minlength="3" maxlength="4"
                        class="form-control" id="security-code" placeholder="000" />
                         -->
                         <div data-aci-speedpay="security-code"></div>                         
                </div>
                <div *ngIf="!cardForm.controls['iframe-security-code'].valid && cardForm.controls['iframe-security-code'].dirty" class="alert alert-danger">
                    Incorrect CVV
                </div>
                </div>
            </div>
          </div>

          <div class="row">

            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label>State</label>
                    <div class="input-group">
<!--  
                        <input type="text" data-aci-speedpay="account-region-code" formControlName="account-region-code"
                          minlength="2" maxlength="3"
                          class="form-control" id="account-region-code" placeholder="State Code" />
 -->

                        <select formControlName="account-region-code" data-aci-speedpay="account-region-code" 
                            class="form-select" id="account-region-code" placeholder="State Code" >
                            <option *ngFor="let state of stateProvinces" [value]="state.stateCode">{{state.stateName}}</option>
                        </select>
 
                      <!-- <div class="input-group-append">
                          <span class="input-group-text"><fa-icon [icon]="faBuilding"></fa-icon></span>
                      </div> -->
                    </div>
                    <div *ngIf="!cardForm.controls['account-region-code'].valid && cardForm.controls['account-region-code'].dirty" class="alert alert-danger">
                        <div *ngIf="true" severity="error">Incorrect state code</div>
                    </div>
                  </div>
            </div>

            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label>Zip Code</label>
                    <div class="input-group">
                      <input type="text" data-aci-speedpay="account-postal-code" formControlName="account-postal-code"
                          minlength="5" maxlength="10"
                          class="form-control" id="account-postal-code" placeholder="Postal Code" />
                      <!-- <div class="input-group-append">
                          <span class="input-group-text"><fa-icon [icon]="faEnvelopeOpen"></fa-icon></span>
                      </div> -->
                    </div>
                    <div *ngIf="!cardForm.controls['account-postal-code'].valid && cardForm.controls['account-postal-code'].dirty" class="alert alert-danger">
                        Incorrect postal code
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label>Payment Nickname</label>
                        <div class="input-group">
                            <input type="text" data-aci-speedpay="funding-account-nickname" formControlName="funding-account-nickname"
                                minlength="0" maxlength="45"
                                class="form-control" placeholder="Enter payment nickname (optional)" id="funding-account-nickname" />
                            <!-- <div class="input-group-append">
                                <span class="input-group-text"><fa-icon [icon]="faCoffee"></fa-icon></span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>            


          </div>

          <div class="dsb-card-footer">
            <!-- 
                    <input type="button" class="dsb-right-btn" data-aci-speedpay="card-submit-button" id="card-submit-button"  value="Submit" [disabled]="!cardForm.valid" />
                    <button class="dsb-right-btn" type="button" (click)="onCancel()">Cancel</button> -->
            
             
                    <div class="button-wrapper">
                        <input type="button" data-aci-speedpay="card-submit-button" class="dsb-sdk-button" id="card-submit-button" value="Add Debit Card" [disabled]="!cardForm.valid" />
                    </div>
            
                    <div class="link-wrapper">
                        <a href='/dsb-funding-accounts'>Cancel</a>
                    </div>

                    <div *ngIf="isDsbMessageShown" class="alert alert-warning alert-dismissible fade show" role="alert">
                        {{dsbMessage}}
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="alert" aria-lable="Close"></button> -->
                        <button type="button" class="btn-close"  aria-lable="Close" (click)="closeDsbMessage()"></button>
                    </div> 
                
                  </div>  <!-- dsb-card-footer -->
            

        </div>  <!-- dsb-card -->



    </div>    <!-- dsb-card-wrapper -->
  </main>
</form>


<!-- <div theme class="dsb-container">
    <div class="row">
        <div class="col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"> </app-brand-header>
                </div>

                <form data-aci-speedpay role="form" [formGroup]="cardForm">

                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>NAME ON ACCOUNT</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-holder-name" formControlName="account-holder-name"
                                            minlength="1" maxlength="45"
                                            class="form-control" id="account-holder-name" placeholder="Account holder's name" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faAddressCard"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!cardForm.controls['account-holder-name'].valid && cardForm.controls['account-holder-name'].dirty" class="alert alert-danger">
                                        Name on account must be provided
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>CARD NUMBER</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="card-number" formControlName="card-number"
                                            pattern="^[0-9]{4}[ ][0-9]{4}[ ][0-9]{4}[ ][0-9]{4}(?:[ ])?(?:[0-9]{3})?$"
                                            class="form-control" id="card-number" placeholder="0000 0000 0000 0000" />
                                    <div class="input-group-append">
                                        <span class="input-group-text"><fa-icon [icon]="faBriefcase"></fa-icon></span>
                                    </div>
                                </div>
                                    <div *ngIf="!cardForm.controls['card-number'].valid && cardForm.controls['card-number'].dirty" class="alert alert-danger">
                                        Incorrect account number
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>EXPIRATION DATE</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="expiration-date" formControlName="expiration-date"
                                            pattern="^[0-9]{2}[/][0-9]{2}$"
                                            class="form-control" id="expiration-date" placeholder="MM/YY" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faCalendar"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!cardForm.controls['expiration-date'].valid && cardForm.controls['expiration-date'].dirty" class="alert alert-danger">
                                        Incorrect expiration date
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>CVV</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="security-code" formControlName="security-code"
                                            pattern="^[0-9]*$" minlength="3" maxlength="4"
                                            class="form-control" id="security-code" placeholder="000" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faUniversity"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!cardForm.controls['security-code'].valid && cardForm.controls['security-code'].dirty" class="alert alert-danger">
                                        Incorrect CVV
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-7">
                                <div class="form-group">
                                    <label>STATE</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-region-code" formControlName="account-region-code"
                                            minlength="2" maxlength="3"
                                            class="form-control" id="account-region-code" placeholder="State Code" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faBuilding"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!cardForm.controls['account-region-code'].valid && cardForm.controls['account-region-code'].dirty" class="alert alert-danger">
                                        <div *ngIf="true" severity="error">Incorrect state code</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-7">
                                <div class="form-group">
                                    <label>ZIP</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-postal-code" formControlName="account-postal-code"
                                            minlength="5" maxlength="10"
                                            class="form-control" id="account-postal-code" placeholder="Postal Code" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faEnvelopeOpen"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!cardForm.controls['account-postal-code'].valid && cardForm.controls['account-postal-code'].dirty" class="alert alert-danger">
                                        Incorrect postal code
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="panel-footer">
                        <div class="row">
                            <div class="btn-toolbar">
                                <input type="button" data-aci-speedpay="card-submit-button" class="btn btn-submit" id="card-submit-button"  value="Submit" [disabled]="!cardForm.valid || showErrorMessage" />
                                <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
                            </div>
                        </div>
                        <div class="row" *ngIf="showErrorMessage">
                            <div class="alert alert-danger" role="alert">
                                {{errorMessage}}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
 -->

